import { ChangeDetectionStrategy, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { GamePlayerModel, MODAL_TOKEN, ModalProvider } from '@core';
import { OrAvatarComponent } from '@ui-components';
import { IonicModule } from '@ionic/angular';
import { commentMapper } from '../../application/utils';
import { CommentModel } from '../../application/interfaces';
import { take } from 'rxjs';
import { UserCommentsService } from '@fair-play/infra';
import { AddCommentSuccessModalComponent } from './add-comment-success-modal/add-comment-success-modal.component';
import { AddCommentCommandHandler, AddCommentCommandPayload } from '../../application/handlers';
import { CommentTypeEnum } from '@core-http';

@Component({
  selector: 'lib-add-comment-modal',
  templateUrl: './add-comment-modal.component.html',
  styleUrls: ['./add-comment-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrAvatarComponent, IonicModule],
  providers: [AddCommentCommandHandler, UserCommentsService]
})
export class AddCommentModalComponent {
  @Input() gameId!: string;
  @Input() player!: GamePlayerModel;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly addCommentCommandHandler: AddCommentCommandHandler = inject(AddCommentCommandHandler);

  readonly comments: CommentModel[] = Object.values(commentMapper);
  readonly selectedComment: WritableSignal<CommentTypeEnum | null> = signal<CommentTypeEnum | null>(null);

  closeModal(): void {
    this.modalProvider.dismissModal$();
  }

  addComent(): void {
    const comment: CommentTypeEnum | null = this.selectedComment();
    if (!comment) return;

    const payload: AddCommentCommandPayload = {
      gameId: this.gameId,
      userId: this.player.userId!,
      commentType: commentMapper[comment].value
    };

    this.addCommentCommandHandler
      .addComment(payload)
      .pipe(take(1))
      .subscribe(() => {
        this.modalProvider.dismissModal$();
        this.confirmationModal();
      });
  }

  select(event: CustomEvent): void {
    this.selectedComment.set(event.detail.value);
  }

  selectBox(value: CommentTypeEnum): void {
    this.selectedComment.set(value);
  }

  isSelected(value: CommentTypeEnum): boolean {
    return this.selectedComment() === value;
  }

  private confirmationModal(): void {
    this.modalProvider
      .showModal$({
        component: AddCommentSuccessModalComponent,
        cssClass: 'present-modal',
        componentProps: {
          player: this.player
        }
      })
      .subscribe(() => this.modalProvider.dismissAllStoredModals());
  }
}
